export default "__VITE_ASSET__DpGtxULG__"